/**
 * The hall of the six schools (ศาลาหกสำนัก, docs/archive/YANYU.md §3 district 6): in a zone whose map has a
 * `schools` landmark (the starting village), a recruiter of every school stands before the hall by
 * the school's banner, and a newcomer can join any school there. They are the World's school
 * masters (`World.schoolMasters`), so talking to one offers that school (`joinSchool`) as a master
 * in the school's own zone does. A school zone keeps only its own master at its plaza.
 */
import { SCHOOLS } from '../data/schools';
import type { SystemHost, WorldSystem } from './types';

export class RecruitersSystem implements WorldSystem {
  readonly name = 'recruiters';

  constructor(private readonly h: SystemHost) {}

  setup(): void {
    const w = this.h.world;
    const hall = w.map.landmarks?.schools;
    if (!hall) return;
    for (const school of Object.values(SCHOOLS)) {
      if (w.schoolMasters.has(school.id)) continue;
      w.schoolMasters.set(
        school.id,
        this.h.add({
          kind: 'npc',
          x: hall.x + school.recruit.dx,
          y: hall.y + school.recruit.dy,
          sprite: school.master.sprite,
          name: school.master.name,
          title: school.master.title,
          facing: 1,
        }),
      );
    }
  }
}
